import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "inset-0 fixed game" }
const _hoisted_2 = {
  class: "city-canvas",
  ref: "canvasRef"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "h-32 w-full top-0 z-20 fixed hidden xl:block" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "h-full mx-auto md:ml-4",
    src: "/assets/images/my-topia.png"
  })
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "bg-brand-darkBlue font-bold text-center text-white text-lg py-2 bottom-20 large-rounded-top question xl:bg-transparent xl:py-4 xl:py-0 xl:px-4 xl:px-0 xl:text-5xl" }
const _hoisted_6 = { class: "bg-brand-darkBlue grid pb-4 answers xl:bg-transparent xl:pb-0 xl:gap-x-2 xl:gap-y-2 xl:gap-2 xl:grid-cols-5" }
const _hoisted_7 = { class: "flex flex-row  items-center justify-center content-row " }
const _hoisted_8 = { class: "flex flex-row ml-auto justify-between items-center  xl:leading-none" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", {
  id: "icon",
  class: "bg-white rounded-full text-brand-lightGreen fas fa-check-circle"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", {
  id: "icon",
  class: "bg-white rounded-full text-brand-lightBlue fas fa-times-circle"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", {
  id: "icon",
  class: "bg-white rounded-full text-brand-lightBlue fas fa-question-circle"
}, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "h-full hint justify-center items-center"
}
const _hoisted_13 = { class: "hint-text" }
const _hoisted_14 = {
  key: 0,
  id: "event",
  class: "flex inset-0 z-40 absolute items-center justify-center",
  style: {"background":"rgba(0, 0, 0, 0.2)"}
}
const _hoisted_15 = { class: "bg-brand-darkBlue rounded-lg py-4 px-4 event" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h2", { class: "font-raleway text-white mb-2" }, "Attention", -1)
const _hoisted_17 = { class: "font-raleway text-white mb-6" }
const _hoisted_18 = { class: "font-raleway text-center" }
const _hoisted_19 = {
  key: 1,
  class: "flex inset-0 z-20 absolute items-end justify-center"
}
const _hoisted_20 = { class: "rounded-lg text-center mb-10 py-4 px-4 md:mb-16" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "mytopia-complete" }, " MyTopia is now complete ", -1)
const _hoisted_22 = {
  key: 2,
  class: "top-0 right-0 absolute dev"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("h2", { class: "font-bold text-lg mb-2 underline" }, "Dev info", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("canvas", _hoisted_2, null, 512),
    _hoisted_3,
    _createVNode("div", {
      id: "question",
      class: ["w-full transition-opacity ease-in-out bottom-0 duration-200 absolute xl:mb-0 xl:px-5", [
        !_ctx.animating && !_ctx.cityComplete
          ? 'opacity-100'
          : 'opacity-0 pointer-events-none',
      ]]
    }, [
      (_ctx.getters.currentQuestion)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getters.currentQuestion.text), 1),
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getters.currentQuestion.answers, (answer, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: ["border-b flex flex-col border-gray-300 mx-4 transition z-40 answer overflow-hidden xl:border-none xl:mt-auto xl:mx-0 xl:px-4", {
              toggled: _ctx.toggled[index],
              'border-none': index === 4,
            }],
                  key: answer.text
                }, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", {
                      class: "cursor-pointer icon-circle",
                      onClick: $event => (_ctx.submitAnswer(answer))
                    }, [
                      _createVNode("i", {
                        class: ["text-brand-darkBlue icon", `fas fa-${answer.icon} `]
                      }, null, 2)
                    ], 8, ["onClick"]),
                    _createVNode("p", {
                      class: "cursor-pointer text-sm px-2 answer-text break-words md:text-normal xl:leading-tight 2xl:text-lg",
                      onClick: $event => (_ctx.submitAnswer(answer))
                    }, _toDisplayString(answer.text), 9, ["onClick"]),
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", {
                        onClick: $event => (_ctx.submitAnswer(answer)),
                        class: ["rounded-full cursor-pointer mr-2", { 'pr-2': _ctx.state.isMobile }]
                      }, [
                        _hoisted_9
                      ], 10, ["onClick"]),
                      (_ctx.toggled[index])
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            onClick: $event => (_ctx.toggled[index] = false),
                            class: "rounded-full cursor-pointer"
                          }, [
                            _hoisted_10
                          ], 8, ["onClick"]))
                        : (_openBlock(), _createBlock("div", {
                            key: 1,
                            onClick: $event => (_ctx.select(index)),
                            class: "rounded-full cursor-pointer"
                          }, [
                            _hoisted_11
                          ], 8, ["onClick"]))
                    ])
                  ]),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.toggled[index])
                        ? (_openBlock(), _createBlock("div", _hoisted_12, [
                            _createVNode("p", _hoisted_13, _toDisplayString(answer.hint), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ], 2))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (
        _ctx.activeEvents.length > 0 &&
          (_ctx.animationStatus === _ctx.AnimationStatus.Waiting ||
            _ctx.animationStatus === _ctx.AnimationStatus.Idle)
      )
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("p", _hoisted_17, _toDisplayString(_ctx.activeEvents[0].text), 1),
            _createVNode("div", _hoisted_18, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.dismissEvent())),
                class: "bg-white bg-brand-pink rounded rounded-full font-bold"
              }, " Ok ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.cityComplete)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("button", {
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.goToResults())),
              class: "bg-brand-pink rounded-full text-white w-64"
            }, " Get your results ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.isDev)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("p", null, "Carbon footprint: " + _toDisplayString(_ctx.state.carbonFootprint), 1),
          _createVNode("p", null, "Economic Prosperity: " + _toDisplayString(_ctx.state.economicProsperity), 1),
          _createVNode("p", null, "Employment: " + _toDisplayString(_ctx.state.employment), 1),
          _createVNode("p", null, " Health, Happiness & Wellbeing: " + _toDisplayString(_ctx.state.healthHappinessAndWellbeing), 1),
          _createVNode("p", null, "Wildlife: " + _toDisplayString(_ctx.state.wildlife), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}